<template>
	<div>
		<div class="week_box">
			<p class="week_title">第一周</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'week',
		data() {
			return {
				
			}
		},
		created() {
			document.documentElement.scrollTop = 0
		},
		methods: {
			
		}
	}
</script>

<style scoped="scoped">
	.week_box{
		width: 620px;
		padding: 30px;
		background-color: rgba(0, 0, 0, 0.5);
		border-radius: 20px;
		box-shadow: 0 0 20px #606468;
	}
	.week_title{
		height: 20px;
		line-height:20px;
		padding-bottom:10px;
		font-size:20px;
		color:#E8E6E6;
		border-bottom:1px #414141 solid;
	}
</style>



// WEBPACK FOOTER //
// src/components/curriculum/Week.vue